<!--
 * @Description: 自动配载设置-新增 addAutoStowage
 * @Author: yuanjiaheng
 * @LastEditors: yuanjiaheng
 * @Date: 2021-07-27 09:24:59
 * @LastEditTime: 2021-08-01 10:52:10
-->
<template>
  <add-or-update pageType="add"></add-or-update>
</template>

<script>
import addOrUpdate from "./components/addOrUpdate.vue";
export default {
  name: "addAutoStowage",
  components: { addOrUpdate }
};
</script>

<style></style>
